import axios from "axios";
import { toast } from "react-toastify";
import { REPORT_AI_BASE_URL } from "../constants/api";
import ReportingUtils from "../utilities/ReportingUtils";

const brsrXbrlAxios = axios.create({
  baseURL: REPORT_AI_BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});

const requestHandler = (request) => {
  return request;
};

const responseHandler = (response) => {
  return response;
};

const errorHandler = (error) => {
  const _ = ReportingUtils.decodeErrorMessage(error?.response?.status, error?.response?.data?.detail);
  toast.error(
    <div>
      <h6>{_.header}</h6>
      <div>{_.message}</div>
    </div>, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: false
  });
  return Promise.reject(error);
};

brsrXbrlAxios.interceptors.request.use(
  function (config) {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["Authorization"] = "Bearer " + accessToken;
    }
    return requestHandler(config);
  },
  function (error) {
    return errorHandler(error);
  }
);

brsrXbrlAxios.interceptors.response.use(
  function (response) {
    return responseHandler(response);
  },
  function (error) {
    return errorHandler(error);
  }
);

export default brsrXbrlAxios;
